import { useState } from 'react';
import UserProfile from '@/models/UserProfile';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon, PencilIcon } from '@heroicons/react/24/outline';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import Tag from '@/components/ui/custom/dataDisplay/Tag';
import TeacherForm from './TeacherForm';
import User from '@/models/User';

interface EditUserProps {
  teacher: User;
  onUpdate?: (userProfile?: UserProfile, teacher?: User) => void;
}

export default function EditTeacher({ teacher }: EditUserProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'manageTeacher',
  });

  const [editMode, setEditMode] = useState(false);
  return (
    <div className="flex flex-col w-full font-rubik pt-5 pb-5 ml-8">
      <div className="flex w-auto items-center gap-8 mb-3 ">
        <Tag
          text={t('addUser.info')}
          icon={<InformationCircleIcon className="w-6 h-6" />}
        />
        <MainButton
          disabled={editMode}
          onClick={() => setEditMode(true)}
          text={t('addUser.edit')}
          icon={<PencilIcon />}
          color="custom"
          className="text-primary"
          dataTestId="editButton"
        />
      </div>
      <TeacherForm
        teacher={teacher}
        formMode="edit"
        disabled={!editMode}
        className="w-[60%] mb-5"
        onCancel={() => setEditMode(false)}
      />
    </div>
  );
}
